import { createTheme as g, ThemeProvider as u } from "@mui/material/styles";
import { d as c } from "../colorManipulator-_J66SCgI.mjs";
const y = u, o = "#00A88F", h = "#E02020", e = "#FFFFFF", n = "#EEEEEE", t = "#939597", m = "#444444", d = "#3E3E3E", i = "#FAFAFA", r = `1px solid ${n}`, v = g({
  palette: {
    background: {
      default: n
      // Set your desired background color here
    },
    primary: {
      main: o
    },
    warning: {
      main: h
    },
    text: {
      primary: d,
      secondary: t
    },
    lightGray: n,
    mediumGray: t,
    darkGray: m
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 0,
      tablet: 760,
      desktop: 1024
    }
  },
  shape: {
    borderRadius: 4
    // Sets the global border radius to 2px
  },
  typography: {
    fontFamily: "Nunito Sans, Arial, sans-serif",
    // Sets Nunito Sans as the default font
    fontSize: 14,
    h1: {
      fontSize: "28px",
      lineHeight: "28px",
      fontWeight: 600
    },
    h2: {
      fontSize: "24px",
      lineHeight: "18px",
      fontWeight: 600
    },
    h3: {
      fontSize: "20px",
      lineHeight: "18px",
      fontWeight: 700
    },
    h4: {
      fontSize: "16px",
      fontWeight: 700,
      marginTop: "12px",
      marginBottom: "12px"
    },
    h5: {
      fontSize: "14px",
      fontWeight: 600
    },
    body1: {
      fontSize: "14px",
      fontWeight: 400,
      // semi bold
      lineHeight: "normal"
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
      // semi bold
      color: t,
      // using the defined color
      lineHeight: "normal"
    },
    subtitle1: {
      fontSize: "14px",
      fontWeight: 700,
      // bold
      lineHeight: "normal"
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 600,
      // semi bold
      color: t,
      // using the defined color
      lineHeight: "normal"
    }
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {
            "--variant-outlinedBorder": "inherit"
          }
        }
      ],
      styleOverrides: {
        root: {
          boxShadow: "none",
          // Removes the box shadow
          textTransform: "none",
          // Removes the uppercase styling from button text
          fontWeight: 700,
          // Sets font weight to 700 (bold) for buttons
          borderRadius: 2,
          lineHeight: "14px",
          padding: "12px 16px",
          "&:hover": {
            boxShadow: "none"
            // Ensures there's no shadow on hover
          },
          "&.mui-theme-hide-label": {
            ".MuiButton-icon": {
              visibility: "hidden"
            }
          }
        },
        text: ({ ownerState: a, theme: l }) => {
          const p = ["primary", "secondary", "error", "info", "success", "warning"].includes(a.color) ? a.color : "primary", s = l.palette[p];
          return {
            padding: 0,
            textDecoration: "underline",
            fontWeight: 700,
            minWidth: 0,
            textAlign: "left",
            "&:hover": {
              color: c(s.main, 0.25),
              // Now TypeScript knows `main` exists
              backgroundColor: "transparent",
              textDecoration: "underline"
            },
            ".MuiButton-endIcon": {
              marginLeft: "4px"
            },
            ".MuiButton-startIcon": {
              marginRight: "4px"
            }
          };
        },
        startIcon: {
          marginRight: "8px",
          marginLeft: 0,
          "& > *:nth-of-type(1)": {
            fontSize: "12px"
            // Ensures the nested icon inherits the font size
          }
        },
        endIcon: {
          marginLeft: "8px",
          marginRight: 0,
          "& > *:nth-of-type(1)": {
            fontSize: "12px"
            // Ensures the nested icon inherits the font size
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          display: "block"
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard",
        fullWidth: !0
      },
      styleOverrides: {
        root: {
          fontSize: "0.875rem"
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#cdcdcd"
        }
      }
    },
    MuiSelect: {
      defaultProps: {
        variant: "standard",
        fullWidth: !0
      },
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          // Set font size to 14px
          ".Mui-select": {
            backgroundColor: o
          },
          "&.secondary": {
            fontWeight: 700,
            ":hover": {
              "::before": {
                borderBottom: "none"
              }
            },
            "::before": {
              borderBottom: "none"
            },
            "::after": {
              borderBottom: "none"
            },
            ".MuiSelect-select": {
              padding: "0 24px 0 0"
            }
          }
        },
        icon: {
          color: o
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: e,
          border: r,
          borderRadius: "4px",
          paddingTop: 0,
          paddingBottom: 0,
          overflow: "hidden"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          display: "block",
          fontSize: "0.875rem",
          // Set font size to 14px
          fontWeight: 600,
          textAlign: "left",
          color: d,
          paddingTop: 8,
          paddingBottom: 8,
          minHeight: "auto",
          whiteSpace: "normal",
          borderBottom: r,
          "&:hover": {
            backgroundColor: i
          },
          "&.Mui-selected": {
            backgroundColor: "rgba(0, 168, 143, 0.25)"
          },
          "&.Mui-selected:hover": {
            backgroundColor: "rgba(0, 168, 143, 0.35)"
          },
          "&:last-child": {
            borderBottom: "none"
          },
          "& a": {
            color: "inherit",
            textDecoration: "none",
            fontSize: "inherit",
            fontWeight: "inherit"
          },
          ".nav-item &": {
            "@media (max-width:900px)": {
              // Mobile
              backgroundColor: i
            }
          }
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          ".MuiListItemText-primary": {
            fontSize: "14px"
          }
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          marginRight: 0
        }
      }
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          display: "none"
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "0 8px 0 0"
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: "8px 0",
          fontSize: "0.875rem"
          // Set font size to 14px for the input element
        },
        inputSizeSmall: {
          height: "0px",
          padding: "16px 0 !important"
        },
        inputAdornedStart: {
          marginLeft: 8
        },
        inputAdornedEnd: {
          marginRight: 8
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: e,
          borderRadius: "4px",
          "&:hover, &.Mui-focused": {
            backgroundColor: e
          },
          "&::before, :hover:not(.Mui-disabled, .Mui-error):before, &::after": {
            borderBottom: "none"
          },
          paddingLeft: "8px"
        },
        input: {
          padding: "12px 8px"
        },
        adornedStart: {
          svg: {
            padding: 0
          }
        },
        adornedEnd: {
          svg: {
            padding: 0
          }
        }
      }
    },
    MuiPagination: {
      defaultProps: {
        siblingCount: 1,
        showFirstButton: !0,
        showLastButton: !0
      },
      styleOverrides: {
        root: {
          color: o
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: t,
          fontWeight: 700,
          padding: 0,
          margin: "0 5px",
          minWidth: 0,
          "&.Mui-selected": {
            backgroundColor: "transparent",
            color: o,
            ":hover": {
              backgroundColor: "transparent"
            }
          },
          ":hover": {
            color: o,
            backgroundColor: "transparent"
          },
          "&.MuiPaginationItem-firstLast": {
            width: "12px"
          },
          "&.MuiPaginationItem-previousNext": {
            width: "12px"
          },
          "&.Mui-selected.Mui-disabled": {
            backgroundColor: "transparent"
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: e,
          border: r,
          padding: 12,
          color: d
        },
        arrow: {
          color: n
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "& a": {
            color: "inherit",
            textDecoration: "none",
            fontSize: "inherit",
            fontWeight: "inherit"
          }
        },
        gutterBottom: {
          marginBottom: ".7em"
        }
      }
    },
    MuiChip: {
      defaultProps: {
        color: "default"
      },
      styleOverrides: {
        root: {
          padding: "0 16px",
          fontWeight: 600,
          "& .MuiChip-deleteIcon": {
            color: e
          },
          "& .MuiChip-icon": {
            color: e
          }
        },
        colorDefault: {
          border: r,
          backgroundColor: i,
          "& .MuiChip-deleteIcon": {
            color: o
          },
          "& .MuiChip-icon": {
            color: t
          }
        },
        colorPrimary: {},
        label: {
          padding: 0
        },
        icon: {
          margin: "0 8px 0 0",
          fontSize: "14px"
        },
        deleteIcon: {
          margin: "0 0 0 16px",
          opacity: 1,
          width: "14px",
          height: "14px",
          boxSizing: "border-box",
          padding: "4px",
          borderRadius: "50% 50%",
          marginRight: "-12px",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,.15)"
          }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderTop: `4px solid ${o}`,
          borderBottom: `2px solid ${o}`
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        fullWidth: !0,
        maxWidth: "sm"
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          padding: "16px 16px 0"
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "16px"
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "16px",
          display: "flex",
          justifyContent: "space-between",
          gap: "12px",
          "> *": {
            flexGrow: 1,
            marginLeft: "0 !important"
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          padding: "6px 8px",
          backgroundColor: "#FFFFFF",
          wordBreak: "break-word"
        },
        head: {
          fontWeight: 700,
          backgroundColor: i
        },
        sizeSmall: {
          fontSize: "12px",
          fontWeight: 500
        }
      }
    },
    MuiMultiSectionDigitalClockSection: {
      styleOverrides: {
        root: {
          width: "70px"
        },
        item: {
          width: "60px",
          margin: "2px 4px"
        }
      }
    }
  }
});
export {
  y as OTCThemeProvider,
  v as default
};
